export const formatMoney = value => {
  const formattedAmount = new Intl.NumberFormat("en-PH", {
    style: "currency",
    currency: "PHP",
  }).format(value);
  return formattedAmount;
};

export const modifiedFormatMoney = value => {
  let numericValue;

  if (typeof value === "string") {
    numericValue = parseFloat(value.replace(/,/g, ""));
  } else {
    numericValue = parseFloat(value);
  }

  if (isNaN(numericValue)) {
    throw new Error("Invalid number format");
  }

  const formattedAmount = new Intl.NumberFormat("en-PH", {
    style: "currency",
    currency: "PHP",
  }).format(numericValue);

  return formattedAmount;
};
